<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <div class="条件区">
      <app-wmsm-WHQRtconditions [show]="true"  [WHQKey]="onQueryClick1()" [ShowBuyer]="true" [ShowVendor]="true" [ShowSecondQuery]="false" [ShowSecondExport]="false" [ShowSecondDown]="false" [Showagree]="false" [showSave]="false" [Showreject]="false" (listenForm)="getFormValue($event)" ></app-wmsm-WHQRtconditions>
    </div>
    </div>
    <nz-card>

    <div >
      <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}}) </strong>
    </div>
    <div class="表格" >
      <nz-table #rowSelectionTable nzShowSizeChanger [nzData]="listOfData"
      (nzCurrentPageDataChange)="onCurrentPageDataChange($event)"  style="margin-bottom: 10px"  nzSize="middle"  (nzPageIndexChange)="myChange($event)"
      [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex' [nzScroll]="{ y: '600px',x:'2200px' }">
        <thead>
          <tr>
            <th scope="col" [nzLeft]="fixedColumn" [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)" nzWidth="50px" ></th>
            <th scope="col"nzWidth="150px" [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)" style="text-align:center;">{{ "PoNo" | translate}}</th>
            <th scope="col" nzWidth="70px" style="text-align:center;">{{ "PoType" | translate}}</th>
            <th scope="col" nzWidth="70px" style="text-align:center;">{{ "table.POLN" | translate}}</th>
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "InvoiceNo" | translate}}</th>
            <th scope="col" nzWidth="120px" style="text-align:center;">{{ "InvoiceDate" | translate}}</th>
            <th scope="col" nzWidth="70px" style="text-align:center;">{{ "table.WHQCurrency" | translate}}</th>
            <th scope="col" nzWidth="160px" style="text-align:center;">{{ "PoAmount" | translate}}</th>
            <th scope="col" nzWidth="160px" style="text-align:center;">{{ "InvoiceAmountBeforeTax" | translate}}</th>
            <th scope="col" nzWidth="140px" style="text-align:center;">{{ "Taxes" | translate}}</th>
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "PA No." | translate}}</th>
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "BillingStatus" | translate}}</th>
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "PR No." | translate}}</th>
            <th scope="col" nzWidth="300px" style="text-align:center;">{{ "PRApplicantId" | translate}}</th>
            <th scope="col" nzWidth="300px" style="text-align:center;">{{ "PRApplicantName" | translate}}</th>
            <th scope="col" nzWidth="300px" style="text-align:center;">{{ "PRApplicantDeptCode" | translate}}</th>
            <th scope="col" nzWidth="300px" style="text-align:center;">{{ "PRApplicantDeptName" | translate}}</th>
            <th scope="col" nzWidth="130px" style="text-align:center;">{{ "IsAcceptance" | translate}}</th>
            <th scope="col" nzWidth="300px" style="text-align:center;">{{ "RtNo" | translate}}</th>
            <th scope="col" nzWidth="300px" style="text-align:center;">{{ "AcNo" | translate}}</th>
            <!-- <th scope="col" nzWidth="130px" style="text-align:center;">{{ "AcStatus" | translate}}</th> -->
            <!-- <th scope="col" nzWidth="160px" style="text-align:center;">{{ "RtTotalAmount" | translate}}</th>
            <th scope="col" nzWidth="160px" style="text-align:center;">{{ "AcTotalAmount" | translate}}</th> -->
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "VendorCode" | translate}}</th>
            <th scope="col" nzWidth="200px" style="text-align:center;">{{ "VendorName" | translate}}</th>
            <th scope="col" nzWidth="90px" style="text-align:center;">{{ "Company" | translate}}</th>
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "SourcerEmplid" | translate}}</th>
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "Buyer" | translate}}</th>
            <th scope="col" nzWidth="120px" style="text-align:center;">{{ "MonthOfNotice" | translate}}</th>
            <th scope="col" nzWidth="120px" style="text-align:center;">{{ "DateOfNotice" | translate}}</th>
            <!-- <th scope="col" nzWidth="150px" style="text-align:center;">{{ "InformVendorName" | translate}}</th> -->
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "ElectronicFileInvoice" | translate}}</th>
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "OtherFiles1" | translate}}</th>
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "BuyerOtherFiles1" | translate}}</th>
            <th scope="col" nzWidth="100px" style="text-align:center;">{{ "ComeFrom" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of rowSelectionTable.data;let i=index">
            <td [nzLeft]="fixedColumn" [nzChecked]="setOfCheckedId.has(data.sId)" (nzCheckedChange)="onItemChecked(data.sId, $event)" ></td>
            <td >{{data.poNo}}</td>
            <td >{{data.category}}</td>
            <td >{{data.poLn}}</td>
            <td >{{data.invoiceNo}}</td>
            <td >{{data.invoiceDate}}</td>
            <td >{{data.currency}}</td>
            <td style="text-align: right; word-break:break-all;">{{data.poAmout | number: '1.2-2' }}</td>
            <td style="text-align: right; word-break:break-all;">{{data.invoiceAmount | number: '1.2-2' }}</td>
            <td style="text-align: right; word-break:break-all;">{{data.taxes | number: '1.2-2' }}</td>
            <td >{{data.paNo}}</td>
            <td >{{data.statementStatus| translate}}</td>
            <td >{{data.prNo}}</td>
            <td >{{data.prApplicant}}</td>
            <td >{{data.prApplicantName}}</td>
            <td >{{data.prApplicantDeptCode}}</td>
            <td >{{data.prApplicantDeptName}}</td>
            <td>{{data.isacceptance || 'N'}}</td>
            <td >{{data.rtNo}}</td>
            <td >{{data.acNo}}</td>
            <!-- <td >{{data.acStatus}}</td> -->
            <!-- <td style="text-align: right; word-break:break-all;">{{data.rtTotalAmount }}</td>
            <td style="text-align: right; word-break:break-all;">{{data.acTotalAmount }}</td> -->
            <td >{{data.vendorCode}}</td>
            <td >{{data.vendorName}}</td>
            <td >{{data.companyCode}}</td>
            <td >{{data.buyer}}</td>
            <td >{{data.buyerName}}</td>
            <td>{{data.monthOfNotice}}</td>
            <td>{{data.dateOfNotice | date:'yyyy-MM-dd'}}</td>
            <td *ngIf="data.invoiceElectronic!='' && data.invoiceElectronic!=null">
              <div >
                <span class="linkLabel" style="text-decoration:underline;color:blue">
                  <a (click)="GetFileTokenOnClick(data)">{{data.invoiceElectronicName}}</a>
                </span>
              </div>
            </td>
            <td *ngIf="data.invoiceElectronic=='' || data.invoiceElectronic==null "></td>

            <td *ngIf="data.otherAttachment!='' && data.otherAttachment!=null">
              <div >
                <span class="linkLabel" style="text-decoration:underline;color:blue">
                  <a (click)="GetOtherFileTokenOnClick(data)">{{data.otherAttachmentName}}</a>
                </span>
              </div>
            </td>
            <td *ngIf="data.otherAttachment=='' || data.otherAttachment==null "></td>

            <td *ngIf="data.purchaseAttachment!='' && data.purchaseAttachment!=null">
              <div >
                <span class="linkLabel" style="text-decoration:underline;color:blue">
                  <a (click)="GetBuyerFileTokenOnClick(data)">{{data.purchaseAttachmentName}}</a>
                </span>
              </div>
            </td>
            <td *ngIf="data.purchaseAttachment=='' || data.purchaseAttachment==null "></td>

            <td style="text-align:center;">{{data.source}}</td>
          </tr>
        </tbody>
      </nz-table>
      <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'" nzShowSizeChanger
      [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]='pageSize' (nzPageSizeChange)="nzPageSizeChange($event)"
      (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
      <ng-template #renderItemTemplate let-type let-page="page">

        <a *ngIf="type === 'page'">{{ page }}</a>
        <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
        <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
      </ng-template>
    </div>
  </nz-card>

</nz-spin>



